import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { Footer, Header, Page } from "@/components/page.tsx";
import { getPaymentFromSessionStorage } from "@/features/payment/utils.ts";
import {
  CardPaymentHelpText,
  CardPaymentInstructions,
} from "@/features/payment/card-payment-instructions";
import { useApplyPayment } from "@/hooks/use-apply-payment";
import { useEffect } from "react";
import { useRemovePayment } from "@/hooks/use-remove-payment";
import { useAudioSlot } from "@/features/audio/kiosk-audio";

export const Route = createFileRoute("/payment-card-screen")({
  component: RouteComponent,
  loader: ({}) => {
    const payment = getPaymentFromSessionStorage();
    if (!payment) {
      console.error("no payment on card screen");
      throw redirect({
        to: "/start-screen",
        reloadDocument: true,
      });
    }
    return payment;
  },
});

function RouteComponent() {
  useAudioSlot("page.payment-card");
  const payment = Route.useLoaderData();
  const navigate = useNavigate();

  const applyPayment = useApplyPayment();
  const removePayment = useRemovePayment();

  useEffect(() => {
    applyPayment.mutate(
      { payment, purchaseType: "KIOSK_BANK_CARD" },
      {
        onSuccess: () => {
          navigate({
            to: "/payment-complete",
          });
        },
        onError: async (err, { payment }) => {
          try {
            await removePayment.mutateAsync({
              key: payment.kioskPaymentNonceKey,
              cause: "error",
              info: err.message,
            });
          } catch (e) {
            console.error(e);
          }
          navigate({
            to: "/payment-selector-screen/$machineId/{-$dryerBundleId}",
            params: {
              machineId: payment.machineId,
              dryerBundleId: payment.dryerBundleId,
            },
          });
        },
      },
    );
  }, []);

  return (
    <Page className="bg-background" skipInactvityModal>
      <Header showUserDetails={false} />
      <CardPaymentInstructions price={payment.price} />
      <Footer helpText={<CardPaymentHelpText />} />
    </Page>
  );
}
